import { handleActions } from "redux-actions";
import { createRoutine } from "redux-saga-routines";

export const fetchStockVoteRoutine = createRoutine("app/voting/FETCH_STOCK_VOTE");
export const toggleStockVoteRoutine = createRoutine(
  "app/voting/TOGGLE_STOCK_VOTE"
);

export const defaultState = {
  byStockId: {}
};

function ensureStockState(state, stockId) {
  const key = String(stockId);
  const existing = state.byStockId[key];

  if (existing) return existing;

  return {
    loading: false,
    error: null,
    voted: null,
    weekStartDate: null
  };
}

function setStockState(state, stockId, nextPartial) {
  const key = String(stockId);
  const prev = ensureStockState(state, stockId);

  return {
    ...state,
    byStockId: {
      ...state.byStockId,
      [key]: {
        ...prev,
        ...nextPartial
      }
    }
  };
}

export default handleActions(
  {
    [fetchStockVoteRoutine.REQUEST]: (state, { payload }) =>
      setStockState(state, payload.stockId, { loading: true, error: null }),
    [fetchStockVoteRoutine.SUCCESS]: (state, { payload }) =>
      setStockState(state, payload.stockId, {
        loading: false,
        error: null,
        voted: payload.voted,
        weekStartDate: payload.weekStartDate
      }),
    [fetchStockVoteRoutine.FAILURE]: (state, { payload, meta }) =>
      setStockState(state, payload?.stockId ?? meta?.stockId, {
        loading: false,
        error: payload?.error ?? payload
      }),

    [toggleStockVoteRoutine.REQUEST]: (state, { payload }) =>
      setStockState(state, payload.stockId, { loading: true, error: null }),
    [toggleStockVoteRoutine.SUCCESS]: (state, { payload }) =>
      setStockState(state, payload.stockId, {
        loading: false,
        error: null,
        voted: payload.voted,
        weekStartDate: payload.weekStartDate
      }),
    [toggleStockVoteRoutine.FAILURE]: (state, { payload, meta }) =>
      setStockState(state, payload?.stockId ?? meta?.stockId, {
        loading: false,
        error: payload?.error ?? payload
      })
  },
  defaultState
);

